import { createContext } from 'react';

export const PaykuContext = createContext();
